<div class="d-flex flex-column justify-content-between" style="max-height: 100vh; min-height: 100vh;height:100%;max-width: 100vw; min-width: 100vw;width:100%">
  <div class="d-flex bg-white">
    <div class="h-100 w-75 d-flex justify-content-center align-items-center position-relative" >
      <img src="assets/Berghaus_Landingpage_v53.jpg"
        style="object-fit:cover; width: 75vw; max-height:calc(100vh - 45px);">
      <img class="avs-login-logo" src="assets/logo/AVS_Verkehrssicherung_HZ_Transparent.png" class="position-absolute"
        style="bottom: 50px; left: 10px; height: 128px">
    </div>
    <div class="card rounded-0 w-25">
      <div class="">
        <div class="card-body login-card-body">
          <span class="d-flex justify-content-center mt-4">
            <img class="avs-login-logo" src="assets/logo/avs.svg">
          </span>
          <div class="login-step-copy mt-5">
            <h4 class="mb-1">{{ getStepTitle() }}</h4>
            <p class="text-secondary mb-0">{{ getStepDescription() }}</p>
          </div>

          <form *ngIf="loginStep === 'credentials'" novalidate (ngSubmit)="onLoginButtonClicked()" #form="ngForm">
            <div class="form-group mt-4">
              <label class="ms-2" for="inputEmail">E-Mail</label>
              <input type="email" class="form-control rounded-0 mt-1" id="inputEmail" name="email"
                aria-describedby="email input" placeholder="E-Mail eingeben..." [(ngModel)]="loginData.email"
                #email="ngModel" required>
              <span *ngIf="!email.control.valid && email.touched" class="text-danger">
                Bitte E-Mail-Adresse eingeben.
              </span>
            </div>
            <div class="form-group">
              <label class="ms-2 mt-2" for="inputPassword">Passwort</label>
              <input type="password" class="form-control rounded-0 mt-1" id="inputPassword" name="password"
                placeholder="Passwort eingeben..." [(ngModel)]="loginData.password" required #password="ngModel">
              <span *ngIf="!password.control.valid && password.touched" class="text-danger">
                Bitte Passwort eingeben.
              </span>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <button class="btn btn-link text-secondary p-0 mt-3" type="button" [disabled]="isLoading"
                (click)="onPasswordForgotClicked()">
                Passwort vergessen?
              </button>
              <button class="btn btn-secondary rounded-0 mt-3" [disabled]="!form.valid || isLoading" type="submit">
                {{ isLoading ? 'Prüfen...' : 'Weiter' }}
              </button>
            </div>
          </form>

          <form *ngIf="loginStep === 'two-factor'" novalidate (ngSubmit)="onTwoFactorButtonClicked()" #twoFactorForm="ngForm">
            <div class="form-group mt-4">
              <label class="ms-2 mt-2" for="inputTwoFactorCode">2FA-Code</label>
              <input type="text" class="form-control rounded-0 mt-1" id="inputTwoFactorCode" name="twoFactorCode"
                placeholder="Code eingeben..." [(ngModel)]="twoFactorCode" required minlength="6" maxlength="12"
                #twoFactorCodeInput="ngModel">
              <span *ngIf="!twoFactorCodeInput.control.valid && twoFactorCodeInput.touched" class="text-danger">
                Bitte einen gültigen Code eingeben.
              </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-4">
              <button class="btn btn-link text-secondary p-0" type="button" (click)="onBackToLoginClicked()">
                Zurück
              </button>
              <button class="btn btn-secondary rounded-0" [disabled]="!twoFactorForm.valid || isLoading" type="submit">
                {{ isLoading ? 'Prüfen...' : 'Anmelden' }}
              </button>
            </div>
          </form>

          <div *ngIf="loginStep === 'two-factor-setup'" class="two-factor-setup mt-4">
            <div class="two-factor-qr-wrapper text-center mb-4" *ngIf="authenticatorQrCodeDataUrl">
              <img [src]="authenticatorQrCodeDataUrl" alt="QR-Code für Authenticator-Setup" class="img-fluid two-factor-qr-image">
            </div>

            <ol class="two-factor-steps mb-4">
              <li>Öffnen Sie Ihre Authenticator-App und legen Sie ein neues Konto an.</li>
              <li>Scannen Sie den QR-Code oder tragen Sie den Secret Key manuell ein.</li>
              <li>Geben Sie danach den erzeugten 6-stelligen Code zur Bestätigung ein.</li>
            </ol>

            <div class="two-factor-secret mb-3" *ngIf="authenticatorSetup?.secretKey">
              <div class="text-secondary small">Secret Key</div>
              <div class="two-factor-secret__value mb-3">{{ authenticatorSetup?.secretKey }}</div>
              <button type="button" class="btn btn-outline-secondary rounded-0" (click)="onCopySecretKeyClicked()">
                Key kopieren
              </button>
            </div>

            <div class="form-group mt-4">
              <label class="ms-2 mt-2" for="inputTwoFactorSetupCode">Bestätigungscode</label>
              <input type="text" class="form-control rounded-0 mt-1" id="inputTwoFactorSetupCode" name="twoFactorSetupCode"
                placeholder="Code eingeben..." [(ngModel)]="twoFactorSetupCode" minlength="6" maxlength="12">
            </div>

            <div class="d-flex justify-content-between align-items-center mt-4">
              <button class="btn btn-link text-secondary p-0" type="button" (click)="onBackToLoginClicked()">
                Zurück
              </button>
              <button class="btn btn-secondary rounded-0" [disabled]="!twoFactorSetupCode.trim() || isLoading" type="button"
                (click)="onCompleteRequiredTwoFactorSetupClicked()">
                {{ isLoading ? 'Prüfen...' : 'Einrichtung abschließen' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <avs-app-footer></avs-app-footer>
  </div>
</div>
